import React from 'react';
import AppService from '../../../services/app';
import { cpfOrCnpjMask, dateMask, celPhoneMask, unMask } from '../../../commons/masks';
import useForm from '../../components/useForm';
import AppForm from '../form';

const AppEditForm = (props) => {
  const { setMessage, goToMenu } = props;
  const app = JSON.parse(sessionStorage.getItem('app'));

  const initialFormValues = {
    cpf_cnpj: cpfOrCnpjMask(app.cpf_cnpj),
    name: app.name,
    email: app.email.toLowerCase(),
    birthday: dateMask(app.birthday),
    phone: celPhoneMask(app.phone),
    password: '',
    passwordNew: '',
    passwordConfirmation: ''
  }

  const {
    values,
    status,
    setStatus,
    stateButton,
    setStateButton,
    handleInputChange
  } = useForm(initialFormValues);

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setStatus('');
    setStateButton("loading");
    if (values.passwordNew && values.passwordNew !== values.passwordConfirmation) {
      setStatus(['danger', 'As senhas não coincidem']);
    } else {
      try {
        const appUpdate = {
          id: app._id,
          name: values.name,
          password: values.password,
          newPassword: values.passwordNew,
          email: values.email,
          birthday: values.birthday.replace(/\//g, '-'),
          phone: unMask(values.phone),
          isReleased: app.isReleased
        }
        const response = await AppService.update(appUpdate);
        await AppService.findByCpf(unMask(values.cpf_cnpj));
        setMessage(['success', response.data.message]);
        goToMenu();
      } catch(e) {
        if (e.response)
          setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
        else
          setStatus(['danger', `${e}`]);
      }
    }
    setStateButton('');
  }

  return (
    <AppForm 
      editRecord={true}
      status={status} 
      stateButton={stateButton} 
      values={values} 
      handleInputChange={handleInputChange}
      handleSubmit={handleSubmit}
      handleClickBack={goToMenu}
    />
  )

}

export default AppEditForm;
